define('modules/ad_form/ad_form_sub_model',['backbone',
  '_',
  'session',
  'modules/form/form_item_collection',
  'modules/form/form_section_model'
], function (Backbone, _, session,
             FormItemCollection,
             FormSectionModel) {
  'use strict';
  var Model = Backbone.Model.extend({
    initialize: function() {
      this.parse();
    },

    parse: function (response, options) {
      var respond = {},
        sections = new Backbone.Collection();

      response = response || this.toJSON();

      _.forEach(response.sections, function (section) {
        var sectionModel = new FormSectionModel(section);

        var itemCollection = new FormItemCollection(section.fields);
        sectionModel.set({fields: itemCollection});
        sections.add(sectionModel);
      });

      delete response.sections;

      _.extend(respond, response);
      _.extend(respond, {sections: sections});

      this.set(respond);
    }
  });

  return Model;
});

